import React from 'react';

const ServiceSection = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-hands-helping text-primary mb-4"></i>
                <h5 className="mb-3">Assistance</h5>
                <p>The CNI assists its clients in project implementation according to contractual terms.</p>
              </div>
            </div>
          </div>
          {/* Add similar height style to other col-lg-2 elements */}
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-code text-primary mb-4"></i>
                <h5 className="mb-3">Application Development</h5>
                <p>Development of major EGOV (Electronic Government) applications.</p>
              </div>
            </div>
          </div>
          {/* Add similar height style to other col-lg-2 elements */}
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-server text-primary mb-4"></i>
                <h5 className="mb-3">Hosting</h5>
                <p>The CNI has a dedicated Data Center for hosting large-scale State applications.</p>
              </div>
            </div>
          </div>
          {/* Add similar height style to other col-lg-2 elements */}
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-shield-alt text-primary mb-4"></i>
                <h5 className="mb-3">Business Continuity</h5>
                <p>Backup and security for critical State information systems.</p>
              </div>
            </div>
          </div>
          {/* Add similar height style to other col-lg-2 elements */}
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-graduation-cap text-primary mb-4"></i>
                <h5 className="mb-3">Training</h5>
                <p>The CNI offers an annual program of high-level seminars.</p>
              </div>
            </div>
          </div>
          {/* Add similar height style to other col-lg-2 elements */}
          <div className="col-lg-2 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item text-center pt-3">
              <div className="p-4" style={{ height: '300px' }}>
                <i className="fa fa-3x fa-network-wired text-primary mb-4"></i>
                <h5 className="mb-3">Network Administration</h5>
                <p>Administration and supervision of networks and security solutions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
